class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger == 'infinite') {
      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  onClickHandler() {
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;
    this.classList.add('loading');
    this.classList.add('disabled');

    const sections = InfiniteScroll.getSections();
    sections.forEach(() => {
      const url = this.dataset.url;
      InfiniteScroll.renderSectionFromFetch(url);
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.onClickHandler();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  static renderSectionFromFetch(url) {
    return fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        InfiniteScroll.renderPagination(html);
        InfiniteScroll.renderProductGridContainer(html);
        GWListState.push(url);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  static renderPagination(html) {
    const grid = document.getElementById('ProductGridContainer');
    const container = grid ? grid.querySelector('.pagination-wrapper') : null;
    if (!container) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    const pagination = parsed ? parsed.querySelector('.pagination-wrapper') : null;
    if (pagination) {
      container.innerHTML = pagination.innerHTML;
    }
    else {
      container.remove();
    }
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('product-grid');
    const products = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
    if (!container || !products) return;
    container.insertAdjacentHTML('beforeend', products.innerHTML);
  }
}
customElements.define('infinite-scroll', InfiniteScroll);

/*
  GW: remember "Load more" pages and the product the shopper opened, so tapping back
  returns them to that product card instead of the top of page 1.
*/
const GWListState = {
  loaded: [],
  lastProduct: '',

  key() {
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.sort();
    return 'gw-ls:' + window.location.pathname + '?' + params.toString();
  },

  read() {
    try {
      return JSON.parse(sessionStorage.getItem(this.key()) || 'null');
    } catch (e) {
      return null;
    }
  },

  push(url) {
    this.loaded.push({ k: this.key(), u: url });
    this.save();
  },

  save() {
    try {
      const k = this.key();
      const urls = this.loaded.filter((e) => e.k === k).map((e) => e.u);
      sessionStorage.setItem(k, JSON.stringify({ urls: urls, y: window.scrollY, p: this.lastProduct }));
    } catch (e) {}
  },

  findCard(path) {
    if (!path) return null;
    const grid = document.getElementById('product-grid');
    if (!grid) return null;
    const links = grid.querySelectorAll('a[href*="/products/"]');
    for (const a of links) {
      if (a.pathname === path) return a.closest('.grid__item') || a;
    }
    return null;
  },

  align(data) {
    const card = this.findCard(data.p);
    if (card) {
      card.scrollIntoView({ block: 'center' });
    } else if (data.y) {
      window.scrollTo(0, data.y);
    }
  },

  /* Keep re-centring on the product while the page grows (hero video, images), for up to 6 seconds or until the shopper scrolls. */
  hold(data) {
    let userMoved = false;
    let timer = null;
    let observer = null;
    const finish = () => {
      userMoved = true;
      if (observer) observer.disconnect();
      clearTimeout(timer);
    };
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach((ev) => window.addEventListener(ev, finish, { once: true, passive: true }));
    const run = () => { if (!userMoved) this.align(data); };
    run();
    if ('ResizeObserver' in window) {
      let pending = null;
      observer = new ResizeObserver(() => {
        if (userMoved) return;
        cancelAnimationFrame(pending);
        pending = requestAnimationFrame(run);
      });
      observer.observe(document.body);
    }
    [300, 900, 1800, 3000, 4500].forEach((ms) => setTimeout(run, ms));
    if (document.readyState !== 'complete') window.addEventListener('load', run, { once: true });
    timer = setTimeout(() => { if (observer) observer.disconnect(); }, 6000);
  },

  async restore() {
    let nav = null;
    try {
      nav = performance.getEntriesByType('navigation')[0];
    } catch (e) {}
    if (!nav || nav.type !== 'back_forward') return;
    if (!document.getElementById('product-grid')) return;

    const data = this.read();
    if (!data || (!data.p && !data.y)) return;

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    const urls = Array.isArray(data.urls) ? data.urls : [];
    for (const url of urls) {
      try {
        const html = await fetch(url).then((r) => r.text());
        InfiniteScroll.renderPagination(html);
        InfiniteScroll.renderProductGridContainer(html);
        this.loaded.push({ k: this.key(), u: url });
      } catch (e) {
        break;
      }
    }

    this.hold(data);
  }
};

document.addEventListener('click', (event) => {
  const link = event.target.closest ? event.target.closest('a[href*="/products/"]') : null;
  if (link) {
    GWListState.lastProduct = link.pathname;
    GWListState.save();
  }
}, true);
window.addEventListener('pagehide', () => GWListState.save());

/* Page restored from the browser's memory (back/forward cache): products are already there, just re-centre. */
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  const data = GWListState.read();
  if (data && data.p && GWListState.findCard(data.p)) GWListState.hold(data);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => GWListState.restore());
} else {
  GWListState.restore();
}
